export default __webpack_public_path__ + "static/media/superfood_thumb.cfb51df4.jpg";